import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContractorTableRow = ({ contractor, onClick }) => {
  const getAvailabilityBadge = (status) => {
    const badges = {
      available: { label: 'Available', className: 'bg-success/10 text-success' },
      busy: { label: 'Busy', className: 'bg-warning/10 text-warning' },
      on_leave: { label: 'On Leave', className: 'bg-muted text-muted-foreground' },
      unavailable: { label: 'Unavailable', className: 'bg-destructive/10 text-destructive' }
    };
    return badges?.[status] || badges?.available;
  };

  const availabilityBadge = getAvailabilityBadge(contractor?.availabilityStatus);
  const rating = contractor?.rating || 0;
  const totalProjects = contractor?.totalProjects || 0;

  return (
    <tr className="border-b border-border hover:bg-muted/30 transition-colors cursor-pointer" onClick={onClick}>
      <td className="px-4 md:px-6 py-4 md:py-5">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
            {contractor?.avatar ? (
              <img src={contractor?.avatar} alt={contractor?.name} className="w-10 h-10 rounded-full object-cover" />
            ) : (
              <Icon name="User" size={20} className="text-primary" />
            )}
          </div>
          <div>
            <p className="font-medium text-foreground">{contractor?.name}</p>
            <p className="text-sm text-muted-foreground">{contractor?.email}</p>
          </div>
        </div>
      </td>
      <td className="px-4 md:px-6 py-4 md:py-5">
        <span className="text-sm text-foreground">{contractor?.role}</span>
      </td>
      <td className="px-4 md:px-6 py-4 md:py-5">
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs font-medium ${availabilityBadge?.className}`}>
          <span className="w-1.5 h-1.5 rounded-full bg-current"></span>
          {availabilityBadge?.label}
        </span>
      </td>
      <td className="px-4 md:px-6 py-4 md:py-5 hidden lg:table-cell">
        <div className="flex items-center gap-1">
          <Icon name="Star" size={16} className="text-accent fill-accent" />
          <span className="text-sm font-medium text-foreground">{rating?.toFixed(1)}</span>
        </div>
      </td>
      <td className="px-4 md:px-6 py-4 md:py-5 hidden lg:table-cell">
        <span className="text-sm text-foreground">{totalProjects} projects</span>
      </td>
      <td className="px-4 md:px-6 py-4 md:py-5">
        <Button
          variant="ghost"
          size="sm"
          iconName="Eye"
          onClick={(e) => {
            e?.stopPropagation();
            onClick();
          }}
        >
          View
        </Button>
      </td>
    </tr>
  );
};

export default ContractorTableRow;